<template>
  <div class="settings">
    <v-container class="pt-10">
      <v-row class="py-2 px-3 pt-1">
        <v-responsive class="overflow-visible">
          <h1 class="subheading grey--text">Organizations</h1>
        </v-responsive>
        <v-btn icon color="grey mr-5" @click.stop="fetchOrganizations">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn dark class="primary" @click.stop="dialogAddOrganization = true">
          Add Organization
        </v-btn>
      </v-row>
      <v-row align="start" justify="start">
        <v-col cols="12" sm="12" md="12">
          <v-card-title>
            All orgs
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="orgs"
            :headers="headers"
            :items="orgs"
            :search="search"
            class="app_background"
            @click:row="seeDetails"
            :items-per-page="-1"
          ></v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog to edit user info -->
    <v-dialog v-model="dialogAddOrganization" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add New Organization</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <p>{{ parentOrgs }}</p>
              <p>{{ selectedParentOrg }}</p>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="New Organization Name*"
                  v-model="newOrganizationName"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-switch v-model="isChildOrg" label="isChildOrg"></v-switch>
              </v-col>
              <v-col cols="12" sm="9" md="9" v-if="isChildOrg">
                <v-select
                  :items="parentOrgs"
                  v-model="selectedParentOrg"
                  item-text="name"
                  label="Parent Org"
                  solo
                  return-object
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
          <p>
            Super importante: dopo aver creato, prima di creare utenti, é
            FONDAMENTALE creare Plan in Chargebee!!
          </p>
        </v-card-text>
        <v-card-actions>
          <p v-if="feedback" class="red--text pl-5">{{ feedback }}</p>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAddOrganization = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="addOrganizations"
            >Add Organization</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { organizationsCollection } from "@/plugins/firebase.js";

export default {
  name: "Organizations",
  title: "Orgs",

  data() {
    return {
      orgs: null,
      parentOrgs: null,

      show: false,
      search: "",
      headers: [
        {
          text: "NAME",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "ORG_ID", value: "id" },
      ],

      dialogAddOrganization: false,
      newOrganizationName: null,
      isChildOrg: false,
      selectedParentOrg: null,

      feedback: null,
    };
  },
  computed: {
    loadedPosts() {
      return this.$store.getters.loadedPosts;
    },
  },
  methods: {
    seeDetails(value) {
      this.$router.push(`/orgs/${value.id}`);
    },
    async fetchOrganizations() {
      const orgs = [];
      await organizationsCollection
        // .where('type', '!=', 'nested-parent')
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            let singleorg = doc.data();
            singleorg.id = doc.id;
            orgs.push(singleorg);
          });
        })
        .catch((err) => console.log(err));
      this.orgs = orgs;
    },
    // async fetchParentOrganizations(){
    //   const orgs = [];
    //   await organizationsCollection
    //   .where("type", "!=", "nested-child")
    //   .get()
    //   .then(function(querySnapshot) {
    //     querySnapshot.forEach(function(doc) {
    //         let singleorg = doc.data();
    //         singleorg.id = doc.id
    //         orgs.push(singleorg)
    //     });
    //   }).catch((err) => console.log(err) );
    //   this.parentOrgs = orgs
    // },
    async addOrganizations() {
      if (this.newOrganizationName) {
        await organizationsCollection
          .add({
            name: this.newOrganizationName,
          })
          .then(function () {
            console.log("New Organization was added");
          })
          .catch(function (error) {
            console.error("Error writing document: ", error);
            this.feedback = error;
          });
        this.newOrganizationName = null;
        this.dialogAddOrganization = false;
      } else {
        this.feedback = "name cannot be empty";
      }
    },
  },
  created() {
    this.fetchOrganizations();
    // this.fetchParentOrganizations()
  },
};
</script>

<style>
</style>